import { parseDate } from '@bm-js/atlascloud-shared'
import Banner from './Banner'
import { useCustomer } from '../utils/hooks'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const FreeTierBanner = () => {
  const customer = useCustomer()
  const { tr } = useTr()
  if (!customer?.freeTierExpiryDate) return null
  return (
    <div className={`mt-[50px] md:ml-[250px] md:mt-0`}>
      <Banner
        content={
          <p
            dangerouslySetInnerHTML={{
              __html: tr(TrKey.freeTierBannerText, {
                date: parseDate(customer.freeTierExpiryDate),
              }),
            }}
          ></p>
        }
      />
    </div>
  )
}

export default FreeTierBanner
